import { Alert } from 'react-bootstrap';

export default function AlertMessage({ alertObject, setAlertObject }) {
    const { variant, alertMessage } = alertObject;

    return (
        <div>
            <Alert variant={variant} onClose={() => setAlertObject({ variant: '', alertMessage: '' })} dismissible>
            {alertMessage}
            </Alert>
        </div>
    )
}
